import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Page } from 'src/components/Page/Page';
import { RoutePath } from 'src/routes/types';
import {
  getDeviceSize,
  getIsMobileWithTouchscreen,
} from 'src/store/agent/selectors';
import { navigationActions } from 'src/store/navigation/slice';
import { setSidesheetSlots } from 'src/store/sidesheet/slice';
import { SidesheetSlotItem } from 'src/store/sidesheet/types';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { DeviceSize } from 'src/types';

import { SearchActions } from './SearchActions/SearchActions';
import { FiltersBottomSheet } from './SearchFilters/SearchFiltersSidesheet/FiltersBottomSheet/FiltersBottomSheet';
import { SearchList } from './SearchList/SearchList';
import { SearchProvider } from './SearchList/SearchProvider';

const modalSidesheetSizes = new Set([
  DeviceSize.XXS,
  DeviceSize.XS,
  DeviceSize.S,
]);

const List: FC = () => {
  return (
    <SearchProvider>
      <SearchList />
    </SearchProvider>
  );
};

export const SearchPage: FC = () => {
  const size = useSelector(getDeviceSize);
  const isMobile = useSelector(getIsMobileWithTouchscreen);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const standardSlotId = 'tabsLevel';
    const modalSlotId = 'tabsLevelModal';

    const standardSlot: SidesheetSlotItem = {
      id: standardSlotId,
      mode: 'standard',
    };
    const modalSlot: SidesheetSlotItem = {
      id: modalSlotId,
      mode: 'modal',
    };
    const isModalSlot = modalSidesheetSizes.has(size);

    dispatch(
      setSidesheetSlots([
        {
          sidesheetId: 'searchFilters',
          slot: isModalSlot ? modalSlot : standardSlot,
        },
      ]),
    );
    dispatch(navigationActions.setSegments([RoutePath.Main, RoutePath.Search]));
  }, [dispatch, size]);

  return (
    <Page actions={<SearchActions />} testId='search'>
      <List />
      {isMobile && <FiltersBottomSheet />}
    </Page>
  );
};

export default SearchPage;
